import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TSnackbarData } from 'common/types/stackbar.type';

export type TState = {
  snackbar: null | TSnackbarData;
};

export const initialState: TState = {
  snackbar: null,
};

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    callSnackbar: (state, action: PayloadAction<TSnackbarData>) => {
      state.snackbar = action.payload;
    },
    clearSnackbarData: state => {
      state.snackbar = null;
    },
  },
  selectors: {
    selectSnackbarData: state => state.snackbar,
  },
});
